module.exports = __webpack_public_path__ + "static/media/safeway-alberstons-logo.ffc93595.png";